import { useRef, useEffect } from 'react';

// eslint-disable-next-line @typescript-eslint/ban-types
const useImmutableFunction = function <F extends Function>(fn: F): F {
  const fnRef = useRef(fn);
  const immutableFn = useRef<F>(((...p) => fnRef.current?.(...p)) as unknown as F);
  useEffect(() => {
    fnRef.current = fn;
  });
  return fn != null ? immutableFn.current : fn;
};
export default useImmutableFunction;